import { render } from "./GreenBox4.vue?vue&type=template&id=edabf2e4"
import script from "./GreenBox4.vue?vue&type=script&lang=js"
export * from "./GreenBox4.vue?vue&type=script&lang=js"

import "./GreenBox4.vue?vue&type=style&index=0&id=edabf2e4&lang=css"

import exportComponent from "/home/runner/work/tre/tre/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__